import React from 'react';
import './SearchInsights.css';
import { formatNumber, calculateSharePercentage } from '../../utils/analyticsHelpers';

const SearchInsights = ({ destinations = [], tripTypes = [] }) => {
    const destinationTotal = destinations.reduce((total, item) => total + Number(item.searches || 0), 0);

    const tripTypeTotal = tripTypes.reduce((total, item) => total + Number(item.searches || 0), 0);

    return (
        <section className='searchInsights'>
            {/* ================================================= */}
            {/* Header */}
            {/* ================================================= */}

            <div className='searchInsightsHeader'>
                <div>
                    <h2>Search Insights</h2>

                    <span>What users are searching for</span>
                </div>
            </div>

            {/* ================================================= */}
            {/* Insights Grid */}
            {/* ================================================= */}

            <div className='searchInsightsGrid'>
                {/* ================================================= */}
                {/* Top Destinations */}
                {/* ================================================= */}

                <div className='searchInsightBlock'>
                    <div className='searchInsightTitle'>
                        <strong>Top Destinations</strong>

                        <span>{formatNumber(destinationTotal)} searches</span>
                    </div>

                    {destinations.length === 0 ? (
                        <div className='searchInsightEmpty'>No destination searches found</div>
                    ) : (
                        <div className='searchInsightList'>
                            {destinations.map((item, index) => {
                                const percentage = calculateSharePercentage(item.searches, destinationTotal);

                                return (
                                    <div className='searchInsightItem' key={item.name || index}>
                                        <div className='searchInsightItemTop'>
                                            <span className='searchInsightRank'>{index + 1}</span>

                                            <span className='searchInsightName'>{item.name}</span>

                                            <strong>{formatNumber(item.searches)}</strong>
                                        </div>

                                        <div className='searchInsightBar'>
                                            <div
                                                className='searchInsightBarFill'
                                                style={{
                                                    width: `${percentage}%`
                                                }}
                                            />
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    )}
                </div>

                {/* ================================================= */}
                {/* Popular Trip Types */}
                {/* ================================================= */}

                <div className='searchInsightBlock'>
                    <div className='searchInsightTitle'>
                        <strong>Popular Trip Types</strong>

                        <span>{formatNumber(tripTypeTotal)} searches</span>
                    </div>

                    {tripTypes.length === 0 ? (
                        <div className='searchInsightEmpty'>No trip type searches found</div>
                    ) : (
                        <div className='searchInsightList'>
                            {tripTypes.map((item, index) => {
                                const percentage = calculateSharePercentage(item.searches, tripTypeTotal);

                                return (
                                    <div className='searchInsightItem' key={item.name || index}>
                                        <div className='searchInsightItemTop'>
                                            <span className='searchInsightRank'>{index + 1}</span>

                                            <span className='searchInsightName'>{item.name}</span>

                                            <strong>{formatNumber(item.searches)}</strong>
                                        </div>

                                        <div className='searchInsightBar'>
                                            <div
                                                className='searchInsightBarFill'
                                                style={{
                                                    width: `${percentage}%`
                                                }}
                                            />
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    )}
                </div>
            </div>
        </section>
    );
};

export default SearchInsights;
